import { render, staticRenderFns } from "./NewEventCategoryPage.vue?vue&type=template&id=3bf388cf&"
import script from "./NewEventCategoryPage.vue?vue&type=script&lang=js&"
export * from "./NewEventCategoryPage.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports